import React from 'react';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/javascript/javascript';
import { isFunction } from 'lodash';

type PreviewOptionsProps = {
  aggregatedOptions: any;
};

export default (props: PreviewOptionsProps) => {
  const { aggregatedOptions } = props;

  const settings = {
    theme: 'monokai',
    mode: 'javascript',
    lineNumbers: true,
    readonly: true
  };

  return (
    <div className="preview-options" style={{ width: 332 }}>
      <CodeMirror
        options={settings}
        value={JSON.stringify(
          aggregatedOptions ?? {},
          function (_, value) {
            if (isFunction(value)) {
              return value.toString();
            }

            return value;
          },
          '  '
        )}
        className={'h-[calc(100vh-315px)]'}
      />
    </div>
  );
};
